var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgJewelleryAndAccessories = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Necklace-Stand-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Necklace Stand 1 Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.76991 2.29688c0 -1.21108 1.02956 -2.250005 2.24336 -2.250005h5.97343c1.1806 0 2.2434 0.906352 2.2434 2.250005 0 0.96098 0.4211 1.82736 1.0858 2.42347L12 11.0362 5.68413 4.72035c0.66465 -0.5961 1.08578 -1.46249 1.08578 -2.42347ZM12.5303 12.6272l7.172 -7.17198c0.2441 0.05989 0.4987 0.09166 0.7601 0.09166h0.7965c1.5124 0 2.7411 1.23892 2.7411 2.75v5.60002c0 0.8678 -0.4354 1.547 -0.9154 2.0291l-0.0173 0.0174 -0.0184 0.0162 -5.6748 5 -0.0166 0.0147 -0.0175 0.0136c-0.4103 0.3206 -0.6961 0.6279 -0.8741 0.9652H21c0.5523 0 1 0.4477 1 1s-0.4477 1 -1 1H3c-0.55228 0 -1 -0.4477 -1 -1s0.44772 -1 1 -1h4.43457c-0.17806 -0.3373 -0.46383 -0.6446 -0.87417 -0.9652l-0.01747 -0.0136 -0.01662 -0.0147 -5.656024 -4.9835C0.223588 15.4708 0 14.6003 0 13.8969V8.29688c0 -1.51108 1.22867 -2.75 2.74115 -2.75h0.79646c0.2614 0 0.51598 -0.03177 0.76007 -0.09166l7.17202 7.17198 0.109 0.109C10.992 13.6547 10 15.3222 10 16.0969c0 1.1 0.9 2 2 2s2 -0.9 2 -2c0 -0.7747 -0.992 -2.4422 -1.5787 -3.3607l0.109 -0.109Z",
    clipRule: "evenodd",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgJewelleryAndAccessories);
export default ForwardRef;